<template>
    <div class="modal fade" id="copy-group-modal" tabindex="-1" role="dialog" aria-labelledby="copy-group-modal" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ __('copy_groups.header') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form id="copy-group-form" action="" method="post" @submit.prevent="copyGroups">
                    <div class="modal-body">
                        <error-message :error="error"></error-message>

                        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                            <div class="form-group" v-if="allModels != null && allModels.length > 0">
                                <label for="select-model-from">{{ __('copy_groups.label.copy_from') }}</label>
                                <select id="select-model-from" class="form-control" required
                                        v-model="modelFromID" @change="updatedFilteredGroups">
                                    <option value="0" disabled>{{ __('text.select_item') }}</option>
                                    <option v-for="{ id, number, name } in filteredModelsFrom" :value="id">
                                        {{ number }}: {{ name }}
                                    </option>
                                </select>
                            </div>
                        </transition>

                        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                            <div v-if="modelToId === 0" key="select-model-to">
                                {{ __('copy_groups.text.select_model_to') }}
                            </div>
                            <div v-else-if="modelFromID === 0" key="select-model-from">
                                {{ __('copy_groups.text.select_model_from') }}
                            </div>
                            <div key="filtered-groups" class="form-group" v-else-if="filteredGroups != null && filteredGroups.length > 0">
                                <label>{{ __('model.group.name', { count: 2 }) | capitalize }}</label>
                                <transition-group name="list-complete" tag="div">
                                    <div class="custom-control custom-checkbox list-complete-item" v-for="group in filteredGroups" :key="group.id">
                                        <input type="checkbox" :id="'copy-check-' + group.id" class="custom-control-input" name="select-group"
                                               v-model="selectedGroupIDs" :value="group.id">
                                        <label :for="'copy-check-' + group.id" class="custom-control-label">{{ group.number }}: {{ group.name }}</label>
                                    </div>
                                </transition-group>
                            </div>
                            <div key="no-filtered-groups" v-else>
                                {{ __('link_groups.text.already_linked') }}
                            </div>
                        </transition>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ __('button.close') }}</button>
                        <button type="submit" class="btn btn-primary" :disabled="globalVars.isLoading">{{ __('copy_groups.button.save') }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorMessage from '../ErrorMessage';

    export default {
        components: {
            ErrorMessage,
        },
        emits: [
            'groups:copied',
        ],
        data() {
            return {
                filteredGroups: [],
                modelFromID: 0,
                selectedGroupIDs: [],
                error: new _Response(),
                StatusMapper: StatusMapper,
            };
        },
        props: {
            allModels: Array,
            modelToId: {
                type: Number,
                default: null,
            },
            groups: {
                type: Array,
                default() {
                    return [];
                },
            },
        },
        watch: {
            modelToId() {
                this.updatedFilteredGroups();
            },
            groups() {
                this.updatedFilteredGroups();
            },
        },
        computed: {
            filteredModelsFrom() {
                return this.allModels.filter(model => model.id !== this.modelToId);
            },
        },
        created() {
            let self = this;

            $(function () {
                $('#copy-group-modal').on('hidden.bs.modal', () => {
                    self.error = new _Error();
                    self.selectedGroupIDs = [];
                    self.resetForm('copy-group-form');
                });
            });
        },
        methods: {
            copyGroups() {
                this.error = new _Error();

                if (!this.modelToId || !this.modelFromID || this.selectedGroupIDs.length === 0) {
                    return;
                }

                axios
                    .put('/api/models/' + this.modelToId + '/groups', {
                        model_from_id: this.modelFromID,
                        group_ids: this.selectedGroupIDs,
                    })
                    .then(response => {
                        if (!_.isEmpty(response)) {
                            this.error = response.data.error;
                            this.selectedGroupIDs = [];

                            if (response.status === HTTP_CREATED) {
                                this.resetForm('copy-group-form');

                                this.$emit('groups:copied', this.selectedGroupIDs);
                            }
                        }
                    })
                    .catch(error => {
                        this.error = this.createErrorFromRequest(error);
                    })
                ;
            },
            async updatedFilteredGroups() {
                this.filteredGroups = await this.getFilteredGroups();
            },
            async getFilteredGroups() {
                if (!this.modelFromID) return [];

                return await axios
                    .get(`/api/models/${this.modelFromID}/groups`)
                    .then(response => {
                        const groupIds = this.groups.map(group => group.id);

                        return response.data.result.filter(group => !groupIds.includes(group.id));
                    })
                    .catch(error => {
                        this.error = this.createErrorFromRequest(error);

                        return [];
                    });
            },
        },
    };
</script>
